<template>
  <div class="subscription-widget-wrapper">
    <div class="w-left">
      <div class="subscription-widget">

        <div class="subscription-inner">
          <!-- Icons -->
          <div class="icon-wrapper">
            <div class="icon-inner">
              <b-icon icon="envelope"></b-icon>
            </div>
          </div>

          <!-- Description text -->
          <div class="description-wrapper">
            <h2 class="text-center">Subscribe</h2>

            <p class="text-center">
              Subscribe to all the latest releases and announcements from Loyal Solutions by registering your email
              address. You can unsubscribe at any time.
            </p>
          </div>

          <!-- Checkbox -->
          <div class="check-wrapper">
            <div class="checkbox-item" >
              <label class="label">
                <input v-model="input.checkboxes.newsletters" class="label-checkbox" type="checkbox" v-on:click="checkboxClick()" />

                <span class="label-text">
                    Newsletters

                    <span class="label-check-wrapper">
                      <span class="label-check">
                          <b-icon icon="check"></b-icon>
                      </span>
                    </span>
                </span>
              </label>
            </div>

            <div class="checkbox-item">
              <label class="label">
                <input v-model="input.checkboxes.reports" class="label-checkbox" type="checkbox" v-on:click="checkboxClick()" />
                <span class="label-text">
                    Reports

                    <span class="label-check-wrapper">
                      <span class="label-check">
                          <b-icon icon="check"></b-icon>
                      </span>
                    </span>
                </span>
              </label>
            </div>

            <div class="checkbox-item">
              <label class="label">
                <input v-model="input.checkboxes.releases" class="label-checkbox" type="checkbox" v-on:click="checkboxClick()" />
                <span class="label-text">
                    Press releases

                    <span class="label-check-wrapper">
                      <span class="label-check">
                          <b-icon icon="check"></b-icon>
                      </span>
                    </span>
                </span>
              </label>
            </div>
          </div>

          <!-- Input -->
          <div class="inputs-wrapper">
            <div role="group">
              <b-form-input id="input-email" v-model="input.email" v-on:focus="resetErrors" :state="inputEmailState" type="text" placeholder="Your email" aria-describedby="input-live-help"></b-form-input>
            </div>

            <div role="group">
              <b-form-input id="input-name" v-model="input.name" v-on:focus="resetErrors" :focus="resetErrors"  :state="inputNameState" type="text" placeholder="Your First Name + Last Name" aria-describedby="input-name-live-help"></b-form-input>
            </div>
          </div>

          <!-- Button -->
          <div class="button-wrapper">
            <app-button-primary id="subscribe-button" text="Subscribe" v-on:click.native="triggerCaptcha" :isLoading="isLoading"/>
            <b-popover triggers="focus" v-if="isErrorMessageVisible" :show="isErrorMessageVisible" placement="top" variant="danger" target="subscribe-button">
              {{ getErrorMessage }}
            </b-popover>
          </div>
        </div>
      </div>
    </div>

    <div class="w-right">

    </div>

    <invisible-captcha-widget
            @OnVerify="onCaptchaVerifyEvent"
            @OnCancel="onCaptchaCancelEvent"
            @OnError="onCaptchaErrorEvent"
            @OnExpired="onCaptchaExpiredEvent" />

    <modal-success id="subscription-success-modal" title="Congratulations!"
                   text="Thank you, we have now received your subscription. You will receive an email to verify your email and activate the subscription."/>

    <modal-error id="subscription-error-modal" title="Oops something went wrong!"
                   text="Please try to fill out the subscription form and submit it again."/>
  </div>
</template>

<script>
  // Buttons
  import AppButtonPrimary from '@/components/ui/buttons/AppButtonPrimary';

  // Api's
  import SubscriptionApi from "@/services/subscription";

  // Widgets
  import InvisibleCaptchaWidget from '@/components/widgets/captcha/InvisibleCaptcha';

  // Modals
  import ModalSuccess from '@/components/ui/modals/ModalSuccess';
  import ModalError from '@/components/ui/modals/ModalError';

  export default {
    name: 'SubscriptionWidget',

    components: {
      AppButtonPrimary, InvisibleCaptchaWidget, ModalSuccess, ModalError
    },

    data() {
      return {
        token: null,

        isLoading: false,

        popovers: {
          disabled: true
        },

        input: {
          name: null,
          email: null,

          checkboxes: {
            releases: false,
            reports: false,
            newsletters: false,
          }
        },

        errorMessage: null,
      }
    },

    methods: {
      checkboxClick() {
        this.resetErrors();
      },

      startLoader() {
        this.isLoading = true;
      },

      stopLoader() {
        this.isLoading = false;
      },

      triggerCaptcha() {
        if (!this.isFormLoading) {
          this.startLoader();

          if (!this.isFormValid) {
            this.setErrors();
            this.stopLoader();

            return;
          }

          this.$emit('triggerCaptcha');
        }
      },

      onCaptchaVerifyEvent(token) {
        this.token = token;
        this.signUp();
      },

      onCaptchaCancelEvent() {
        this.stopLoader();
      },

      onCaptchaErrorEvent() {
        this.stopLoader();
      },

      onCaptchaExpiredEvent() {
        this.stopLoader();
      },

      resetErrors() {
        this.errorMessage = null;
      },

      setErrors() {
        this.resetErrors();

        if (!this.isValidEmail && !this.isValidName && !this.isValidSubscriptionType) {
          this.errorMessage = 'Please fill in the form to submit.';
        } else if (!this.isValidEmail) {
          this.errorMessage = 'Please enter a valid email in email field.';
        } else if (!this.isValidName) {
          this.errorMessage = 'Please enter at least 3 letters in name field.';
        } else if (!this.isValidSubscriptionType) {
          this.errorMessage = 'Please select which type of subscription you want to receive.';
        }
      },

      clearForm() {
        this.input = {
          name: null,
          email: null,
          checkboxes: {
            releases: false,
            reports: false,
            newsletters: false,
          }
        };
      },

      signUp() {
        const formData = new FormData();
        formData.append('g-recaptcha-response', this.getCaptchaVerifyToken);
        formData.append('subscriptionUniqueIdentifier', process.env.VUE_APP_SUBSCRIPTION_UNIQUE_IDENTIFIER_KEY);
        formData.append('replylanguage', 'en');
        formData.append('name', this.getInputName);
        formData.append('email', this.getInputEmail);

        if (this.input.checkboxes.reports) {
          formData.append('informationtype', 'kmk,rpt,rdv');
        }

        if (this.input.checkboxes.releases) {
          formData.append('informationtype', 'prm');
        }

        if (this.input.checkboxes.releases) {
          formData.append('informationtype', 'nbr');
        }

        const data = {
          params: formData
        }

        let _this = this;
        new SubscriptionApi(data, { urlExtension: 'SubscribeWithCaptcha' }).post(function (response) {
          _this.stopLoader();
          _this.clearForm();

          if (!response.status || response.status !== 200) {
            _this.$root.$emit('bv::show::modal', 'subscription-error-modal');
            return;
          }

          _this.$root.$emit('bv::show::modal', 'subscription-success-modal');
        });
      },
    },

    computed: {
      getCaptchaVerifyToken() {
        return this.token;
      },

      inputEmailState() {
        const email = this.input.email;

        if (email && email.length > 0) {
          return !!this.isValidEmail;
        }

        return null;
      },

      inputNameState() {
        const name = this.input.name;

        if (name && name.length > 0) {
          return !!this.isValidName;
        }
        
        return null;
      },

      isFormLoading() {
        return this.isLoading;
      },

      isFormValid() {
        return this.isValidEmail && this.isValidName && this.isValidSubscriptionType;
      },

      isValidEmail() {
        return /\S+@\S+\.\S+/.test(this.input.email);
      },

      isValidName() {
        return !!this.input.name && this.input.name.length >= 3;
      },

      isValidSubscriptionType() {
        const releases    = this.input.checkboxes.releases;
        const reports     = this.input.checkboxes.reports;
        const newsletters = this.input.checkboxes.newsletters;

        return !!releases || !!reports || !!newsletters;
      },

      getInputName() {
        return this.input.name;
      },

      getInputEmail() {
        return this.input.email;
      },

      getErrorMessage() {
        return this.errorMessage;
      },

      isErrorMessageVisible() {
        return !!this.errorMessage;
      },

   /*   subscriptionButtonActive() {
        return !this.isFormValid;
      },*/
    },
  }
</script>

<style scoped lang="scss">
  .subscription-widget-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    background-image: url("~@/assets/images/corporateGovernance/banner.jpg");
    background-repeat: no-repeat, no-repeat;
    background-size: cover;
    background-position: 0 70%;
   // background-position: right top, right top;

    .w-left {
      width: 100%;
      height: 100%;
      background-color: #192e5b;

      .subscription-widget {
        padding: 0 16px;
        width: 100%;

        .subscription-inner {
          width: 100%;
          max-width: 500px;
          margin: auto;
          padding-top: 60px;
          padding-bottom: 60px;
          color: white;
        }
      }
    }

    .w-right {
      width: 100%;
      height: 100%;
    }

    @media (min-width: 1156px) {
      .w-left {
        .subscription-inner {
          width: 100%;
          padding-left: calc((100% - 570px) + 16px);
        }
      }
    }

    @media (min-width: 1000px) {
      flex-direction: row;

      .w-left {
        width: 50%;

        .subscription-widget {
          .subscription-inner {
            margin: unset;
            max-width: 100%;
          }
        }
      }

      .w-right {
        width: 50%;
      }
    }

    // Icons
    .icon-wrapper {
      display: flex;
      justify-content: center;
      margin-bottom: 30px;

      .icon-inner {
        padding: 20px;
        border: 1px solid white;
        background-color: white;
        border-radius: 50%;

        svg {
          color: #192e5b;
          font-size: 50px;
          line-height: 50px;
        }
      }
    }

    // Description
    .description-wrapper {
      width: 100%;
      max-width: 600px;
      margin: auto;
    }

    // Input
    .inputs-wrapper {
      width: 100%;
      margin: auto;

      input {
        border-radius: 4px;
        border: 1px solid #dedede;
        margin-bottom: 30px;

        &::-webkit-input-placeholder {
          text-align: center;
          color: #838383;
        }

        &:-moz-placeholder { /* Firefox 18- */
          text-align: center;
          color: #838383;
        }

        &::-moz-placeholder {  /* Firefox 19+ */
          text-align: center;
          color: #838383;
        }

        &:-ms-input-placeholder {
          text-align: center;
          color: #838383;
        }
      }

      @media (min-width: 1000px) {
        max-width: 300px;
      }
    }

    // Button
    .button-wrapper {
      width: 100%;
      display: flex;
      justify-content: center;

      /deep/ button {
        margin-bottom: 0;
      }
    }

    // Checkbox
    .check-wrapper {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-bottom: 30px;

      .checkbox-item {
        padding: 0 15px 15px 15px;

        .label-text {
          display: flex;
          flex-direction: row-reverse;
          align-items: center;
          color: white;
        }

        .label-check-wrapper {
          width: 24px;
          height: 24px;
          margin-right: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .label-checkbox {
          display: none;
        }
      }

      @media (min-width: 1000px) {
        flex-direction: row;
      }
    }

    .label-check {
      border-radius: 50%;
      background: white;
      vertical-align: middle;
      width: 24px;
      height: 24px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: border .3s ease;

      svg {
        opacity: 0.2;
        font-size: 20px;
        line-height: 20px;
        color: transparent;
        transition: opacity .3s .1s ease;
        -webkit-text-stroke: 3px rgba(0,0,0,.5);
      }

      &:hover {
        border: 5px solid rgba(0,0,0,0.2);
      }
    }

    .label-checkbox:checked + .label-text .label-check {
      animation: check .5s cubic-bezier(0.895, 0.030, 0.685, 0.220) forwards;

      svg {
        opacity: 1;
        transform: scale(0);
        color: white;
        animation: icon .3s cubic-bezier(1.000, 0.008, 0.565, 1.650) .1s 1 forwards;
      }
    }

    @keyframes icon {
      from {
        opacity: 0;
        transform: scale(0.3);
      }

      to {
        opacity: 1;
        transform: scale(1)
      }
    }

    @keyframes check {
      0% {
        width: 5px;
        height: 5px;
        border-width: 5px;
      }

      10% {
        width: 10px;
        height: 10px;
        opacity: 0.1;
        background: rgba(0,0,0,0.2);
        border-width: 15px;
      }

      12% {
        width: 15px;
        height: 15px;
        opacity: 0.4;
        background: rgba(0,0,0,0.1);
        border-width: 0;
      }

      50% {
        width: 24px;
        height: 24px;
        background: #60be6f;
        border: 0;
        opacity: 0.6;
      }

      100% {
        width: 24px;
        height: 24px;
        background: #60be6f;
        border: 0;
        opacity: 1;
      }
    }

  }
</style>
